import { Bar } from "react-chartjs-2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../AppProvider";
import { faLoader } from "../../../utilities/fontawesomeIcons";
import moment from "moment";
import { useShipmentsPerformancesContext } from "../providers/ShipmentsPerformances";
import { transformStringToColor } from "../../../utilities/utilities";
import { Carrier } from "../../../Models/Carrier";
import React, { useMemo } from "react";
import { useInView } from "react-intersection-observer";

const AverageDeliveryTimeByCarrier = React.memo(() => {
  const { dictionary } = useAppContext();
  const { data, loader, filters } = useShipmentsPerformancesContext();
  const { ref, inView } = useInView({ triggerOnce: true });

  const barContent = useMemo(() => {
    if (!inView || !data?.length) return null;

    const dataToDisplay = {
      labels: data?.map((s) => (s.type as Carrier).name.split(" ")),
      datasets: [
        {
          data: data?.map((s) => (s.average || 0).toFixed(2)) || [],
          backgroundColor:
            data?.map((s) =>
              transformStringToColor((s.type as Carrier).code)
            ) || [],
        },
      ],
    };

    return (
      <Bar
        className="mt-2"
        data={dataToDisplay}
        options={{
          indexAxis: "y",
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              beginAtZero: true,
              min: 0,
              ticks: {
                stepSize: 0.5,
              },
              title: {
                display: true,
                text: dictionary.times.working_days,
              },
            },
            y: {
              beginAtZero: true,
              min: 0,
              ticks: {
                stepSize: 0.5,
              },
              title: {
                display: true,
                text: dictionary.registries.carrier,
              },
            },
          },
        }}
      />
    );
  }, [inView, data]);

  return (
    <div ref={ref} className="box-container text-center h-100">
      <div className="row align-items-center mb-1">
        <div className="col">
          <label className="label-4">
            {dictionary.kpi.delivery_performance}
          </label>
          <label className="label-2">
            {moment(filters.start).isSame(moment(filters.end), "day")
              ? moment(filters.start).format("DD/MM/YYYY")
              : moment(filters.start).format("DD/MM/YYYY") +
                " - " +
                moment(filters.end).format("DD/MM/YYYY")}
          </label>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label className="label-5">
            {dictionary.kpi.delivery_performance_desc}
          </label>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col">
          {loader ? (
            <FontAwesomeIcon icon={faLoader} spin size="4x" />
          ) : data?.length ? (
            barContent
          ) : (
            <label className="label-3">
              {dictionary.messages.no_results_found}
            </label>
          )}
        </div>
      </div>
    </div>
  );
});

export default AverageDeliveryTimeByCarrier;
